/**
 * ex: [{ messageType: 'TEXT', textContent: ''}, { messageType: 'IMAGE', imageContent: ''}]
 * convert to text: '' and image: ''
 * reconvert to [{ messageType: 'TEXT', textContent: ''}, { messageType: 'IMAGE', imageContent: ''}]
 */

import { filter } from 'lodash-es';
import { TypeSource } from './NewTodo';

export const convertMessageToTextAndImage = (messages: string[]) => {
  try {
    const msgs = messages.map((e) => JSON.parse(e.replace(/\n/g, '\\n')));
    const text = msgs.filter((message: any) => message.messageType === 'TEXT');
    const image = msgs.filter((message: any) => message.messageType === 'IMAGE');
    return { text: text?.[0]?.textContent || '', images: image?.map((e) => e.imageContent) || [] };
  } catch (_e) {
    return { text: '', images: [] };
  }
};

export const convertTextAndImageToMessage = (text: string, images: string[]) => {
  const textObj = { messageType: 'TEXT', textContent: text };
  const imageObj = images.map((e) => ({ messageType: 'IMAGE', imageContent: e }));
  return [JSON.stringify(textObj), ...imageObj.map((e) => JSON.stringify(e))];
};

export const isContentEmpty = (content: string[]) => {
  try {
    if (!content || content?.length === 0) return true;
    if (content?.length === 1) {
      const obj = JSON.parse(content[0]);
      if (obj.messageType === 'TEXT') {
        return obj.textContent === '';
      }
    }
  } catch (e) {
    return true;
  }
};

export const getValidTypeSource = (
  typeSource: TypeSource,
  platform: General.PlatformUpperCase,
): TypeSource => {
  return filter(typeSource, (e) => {
    if (e?.origin?.source === 0 && e.enableManualCreate === false) return false;
    if (e?.origin?.source === 0 && e.enable === false) return false;
    if (e?.origin?.source === 0 && [7, 8].includes(e.type) && platform !== 'SHOPEE') return false;

    return true;
  });
};

export const isReturnOrderEnable = (operateResult: Todo.ResultType, type: Todo.Type) => {
  return operateResult === 'RETURN_GOODS_REFUND' || type === 7;
};

export const getReturnSnList = (trade?: Conversation.Trade.Vo) => {
  if (!trade?.items) return [];

  return trade?.items.reduce<string[]>((res, { refundReason = [] }) => {
    return refundReason.reduce((res, { returnSn }) => {
      if (!res.includes(returnSn)) {
        res.push(returnSn);
      }

      return res;
    }, res);
  }, []);
};
